import * as THREE from 'three';
const toRadians = (angle) => {
  return angle * (Math.PI / 180);
};

export const getCameraDistance = (object3D, w, h, isElevation, dim) => {
  const bbox = new THREE.Box3();
  bbox.setFromObject(object3D);

  const geo = new THREE.BoxGeometry(dim.width, 1, dim.length);
  geo.computeBoundingSphere();
  const geoAspect = dim.width / dim.length;
  const canvasAspect = w / h;
  const rad = geo.boundingSphere.radius * 0.5;
  const center = geo.boundingSphere.center;
  const dist =
    rad /
    Math.tan(
      toRadians(
        45 * (geoAspect > canvasAspect ? canvasAspect : Math.max(geoAspect, 1))
      ) / 2
    );
  return { dist, bbox, rad, center };
};

const constrainToBounds = (vec, bbox) => {
  const cVec = vec.clone();
  const margin = 0.6;

  if (cVec.x < bbox.min.x) {
    cVec.setX(bbox.min.x + margin);
  } else if (cVec.x > bbox.max.x) {
    cVec.setX(bbox.max.x - margin);
  }

  if (cVec.y < bbox.min.y) {
    cVec.setY(bbox.min.y + margin * 2);
  } else if (cVec.y > bbox.max.y) {
    cVec.setY(bbox.max.y - margin * 2);
  }

  return cVec;
};
const getMidPoint = (box) => {
  return new THREE.Vector3(0, 0, 0);
};
export const viewSet = (scene, width, height, dim) => {
  const ob = scene.scene.getObjectByName('global-object');
  const isElevation = false;
  const { dist, bbox } = getCameraDistance(ob, width, height, isElevation, dim);

  const pos = scene.camera.position;
  const target = new THREE.Vector3(0, 65, 0);
  let src = scene.state.cameraProps.position.clone();

  src.normalize();
  src.multiplyScalar(dist);
  src.y = 65;
  // scene.camera.lookAt(target);

  const { fov, near, far, position, quaternion } = scene.camera;

  scene.setState(
    {
      cameraProps: {
        position: src,
        quaternion: scene.state.cameraProps.quaternion
      }
    },
    () => {
      scene.forceUpdate();
      setTimeout(scene._renderTrigger, 0);
    }
  );
  // }
};



// WEBPACK FOOTER //
// ./src/components/Results/ResultsScene/sceneUtils.js